import { ExportConfigurationsStorage } from "@dandelion/core/storages";
import { ExportButtonConfiguration, parseElementWithZod, ZexportButtonConfigs, ZexportButtonConfigsSchema, ZodSchemas } from "@dandelion/core";
import { PreferenceValue } from "../entities/Preference";
import { inject, injectable } from "inversify";
import { NamedStorages } from "../enum/NamedStorages";
import { PreferencesStorageInterface } from "../interfaces/PreferencesStorageInterface";
import { Preferences } from "../enum/Preferences";

@injectable()
export class ExportConfigurationsStorageForProsafe extends ExportConfigurationsStorage {
    constructor(protected standardExportConfigs: Array<ExportButtonConfiguration>,
        @inject(NamedStorages.CentrePreferenceStorage) protected centrePreferencesStorage: PreferencesStorageInterface,
    ) {
        super(standardExportConfigs);
    }


    async saveAllExportButtonConfigs(buttons: Array<ExportButtonConfiguration>, storage: string) {
        try {
            const json = JSON.stringify(buttons);

            if (storage === "customExports") {
                const preferenceValue: PreferenceValue = {
                    preferenceName: Preferences.CUSTOMEXPORTS,
                    value: json,
                };
                await this.centrePreferencesStorage.savePreference(preferenceValue);
            }
        } catch (error) {
            console.error("Errore durante il salvataggio dei bottoni export:", error);
        }
    }

    async getExportButtonConfig(storage: string): Promise<Array<ExportButtonConfiguration>> {
        if (storage === 'standardExports') {
            return this.standardExportConfigs;
        }

        if (storage === 'customExports') {
            let stored = (await this.centrePreferencesStorage.getPreference(storage)).value;
            if (!stored) {
                await this.saveAllExportButtonConfigs([], storage);
                return [];
            }

            try {
                return parseElementWithZod(
                    ZexportButtonConfigsSchema,
                    ZodSchemas.EXPORT_BUTTON_CONFIG,
                    JSON.parse(stored!)
                ) as ZexportButtonConfigs;
            } catch (error) {
                console.error("Errore nel parsing dei bottoni export:", error);
                return [];
            }
        }

        return [];
    }
}